module.exports = __webpack_public_path__ + "static/media/SchorTax.a648a2fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NavBar/assets/SchorTax.png
// module id = 23
// module chunks = 0